import { createSagas } from "redux-box";
import { call, put } from "redux-saga/effects";
import swal from "sweetalert2";
import api from "@s/api/wordsinfo";

export default createSagas({
  REQUEST_WORDS_INFO: function* ({ offset, search, themes }) {
    try {
      yield put({ type: "SET_LOADING", isLoading: true });

      const response = yield call(api.getWordsInfo, offset, search, themes);
      if (response) {
        yield put({ type: "SET_WORDS", words: response.result || [] });
        yield put({
          type: "SET_PAGINATION",
          pagination: {
            count: response.count,
            next_page: response.next_page,
            prev_page: response.prev_page,
            offset: response.offset,
            has_next: response.has_next,
          },
        });
      }
    } catch (err) {
      console.error("wordsinfo/REQUEST_WORDS_INFO error:", err);
      swal("Error", "Failed to load words", "error");
    } finally {
      yield put({ type: "SET_LOADING", isLoading: false });
    }
  },

  CREATE_WORD_INFO: function* ({ payload }) {
    try {
      yield call(api.createWordInfo, payload);
      swal("Success", "Word created successfully", "success");
      yield put({ type: "HIDE_MODAL" });
      yield put({ type: "REQUEST_WORDS_INFO", offset: 0, search: "", themes: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to create word";
      swal("Error", msg, "error");
    }
  },

  UPDATE_WORD_INFO: function* ({ id, payload }) {
    try {
      yield call(api.updateWordInfo, id, payload);
      swal("Success", "Word updated successfully", "success");
      yield put({ type: "HIDE_MODAL" });
      yield put({ type: "REQUEST_WORDS_INFO", offset: 0, search: "", themes: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to update word";
      swal("Error", msg, "error");
    }
  },

  DELETE_WORD_INFO: function* ({ id }) {
    try {
      yield call(api.deleteWordInfo, id);
      swal("Success", "Word deleted successfully", "success");
      yield put({ type: "REQUEST_WORDS_INFO", offset: 0, search: "", themes: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to delete word";
      swal("Error", msg, "error");
    }
  },
});
